import React, { useEffect, useState, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./assets/sass/main.scss"
import AdminLayout from "layouts/Admin.jsx";
import Login from "components/Login/Login.js";
import ResetPassword from "components/ResetPassword/ResetPassword.js";
import { RedisDataContext, routeConfig } from "context/RedisDataContext";
import sideBarRoutes from "./utilities/SidebarRoute";
import {SidebarProvider} from "./context/SidebarContext"
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { LanguageContext } from "context/LanguageContext";
import { useTranslation } from 'react-i18next';
import { EventPassPage } from "views/EventPassPage"
import { EventLuckyDraw } from "views/EventLuckyDraw";
import { VegRecipeUI } from "views/VegRecipeUI";
import { NonVegRecipeUI } from "views/NonVegRecipeUI";
import { LuminaRecipesPage } from "views/LuminaRecipesPage";
import "./i18";
import { applyThemeColors } from 'utilities/themeUtils'
import QrCode from "views/qr-code";
import CallToAction from "views/calltoaction";
import cookieManagement from 'utilities/Cookie';
import Cookies from 'universal-cookie';
import { WizardDataContext } from "context/WizardDataContext";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import WMS3D from "./views/PageType-6"
import 'antd/dist/antd.min.css'; 

const cookies = new Cookies();

const App = props => {
  const { t, i18n } = useTranslation();
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const [finalSideBar, setFinalSideBar] = useState([]);
  const [language, setLanguage] = useState([]);
  const featureBluePrint = useState({});
  const globalLoaderValue = useState('0');
  const [hasError, setHasError] = useState({
    error: false,
    message: ""
  });
  const [wizardData, setWizardData] = useState({
    productsView: [],
    productsDetail: []
  })
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',

    }
  ]

  applyThemeColors();


  const loadingMarkup = (
    <div className="py-4 text-center">
      <h3>Loading..</h3>
    </div>
  )

  useEffect(() => {
    cookies.get('clientToken') == undefined ? cookieManagement.saveClientTokenToCookie() : cookies.get('clientToken');
  }, []);

  useEffect(() => {
    if (cookies.get('accessToken')) {
      if (window.location.pathname !== "/3d-wms" &&
         window.location.pathname !== "/lumina-2025" && window.location.pathname !== "/pre-lumina-2025" 
         && window.location.pathname !== "/lumina-veg-2025" && window.location.pathname !== "/lumina-non-veg-2025") {
        if (localStorage.getItem('newSidebar') === 'undefined') {
          return null;
        }
        else {
          let sideBardata = JSON.parse(localStorage.getItem('newSidebar'));
          let { features } = sideBardata.data;
          // let chec = JSON.parse(localStorage.getItem('newSidebar'));
          if (cookies.get('customer_id') === '13' || cookies.get('customer_id') === '12') {
            const homeIndex = features.findIndex((el) => el.name === 'Home');
            if (homeIndex !== -1) {
              const routeAlreadyInserted = routeConfig.some((route) =>
                features.some((feature) => feature.name === route.name)
              );

              if (!routeAlreadyInserted) {
                features.splice(homeIndex + 1, 0, ...routeConfig);
              }
            }
          }
          sideBardata.data.features = features;
          localStorage.setItem('newSidebar', JSON.stringify(sideBardata));

          const sidebarWithRoutes = sideBarRoutes.setSideBarRoutes(sideBardata);
          setFinalSideBar([...sidebarWithRoutes]);
        }
      }
    }
  }, [cookies.get('accessToken')]);

  // useEffect(() => {
  //   if (cookies.get('accessToken')) {
  //    if(localStorage.getItem('newSidebar') === 'undefined'){
  //     return null
  //   }else{
  //   let chec = JSON.parse(localStorage.getItem('newSidebar'));
  //     setFinalSideBar(sideBarRoutes.setSideBarRoutes(chec));
  //   }
  //   }
  // }, [cookies.get('accessToken')]);

  // useEffect(() => {
  //   if (i18n.language === 'chi') {
  //     let  chineseyml= JSON.parse(localStorage.getItem('chineseSidebar'));
  //     // setLanguage(LanguageRoutes.setLanguageRoutes(chineseyml))
  //   }
  // }, [i18n.language]);

  if(window.location.pathname !== "/login" || cookies.get('accessToken')){
    localStorage.setItem("redirectPath", window.location.pathname)
  }

  if (hasError.error) {
    return <ErrorFallback error={hasError.message} />
  } 

  return (
    <BrowserRouter>
    <Suspense fallback={loadingMarkup}>
      <Route path="/health-check" render={() => <div><p>Health Check - Success</p></div>} />
      <GlobalLoadIndicator.Provider value={globalLoaderValue}>
        <FeatureBlueprintContext.Provider value={featureBluePrint}>
          <RedisDataContext.Provider value={finalSideBar}>
            <LanguageContext.Provider value={language}>
            <SidebarProvider>
            <WizardDataContext.Provider value={[wizardData, setWizardData]}>
            <Switch>
              <Route path="/admin" render={props => <AdminLayout setHasError={setHasError} {...props} />} />
              <Route path="/login" exact render={props => <Login setHasError={setHasError} {...props}/>} />
              <Route path="/qr-code" exact component={QrCode} />
              <Route path="/product-detail" exact component={CallToAction} />
              <Route path="/" exact render={props => <Login setHasError={setHasError} {...props}/>} />
              <Route path="/resetpassword" render={props => <ResetPassword setHasError={setHasError} {...props}/>} />
              {/* <Route path="/admin/dashboard" component={PageType7} /> */}
              <Route path="/3d-wms" component={WMS3D} />
              <Route path="/:city/lumina-2026" exact component={EventPassPage} />
              <Route path="/:city/pre-lumina-2026" exact component={EventLuckyDraw} />
              <Route path="/lumina-veg-2026" component={VegRecipeUI} />
              <Route path="/lumina-non-veg-2026" component={NonVegRecipeUI} />
              <Route path="/lumina-recipes-2026" component={LuminaRecipesPage} />
            </Switch>
            </WizardDataContext.Provider>
            </SidebarProvider>
            </LanguageContext.Provider>
          </RedisDataContext.Provider>
        </FeatureBlueprintContext.Provider>
      </GlobalLoadIndicator.Provider>
      </Suspense>
    </BrowserRouter>
  );
}


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<ErrorBoundary>
              <App />
            </ErrorBoundary>
            );
